/**
 * StepIndicator
 * =============
 *
 * A lightweight text-based step counter for multi-step informant management
 * flows.  Displays "Step X of Y" to orient the user without adding visual
 * clutter.
 *
 * Follows the same pattern used in PatientSetupForm's "Step X of Y" header
 * for consistency across the application.
 */

import React from 'react';

/**
 * @param {Object}   props
 * @param {string[]} props.steps       – Array of step labels (used only for count)
 * @param {number}   props.currentStep – Zero-based index of the active step
 */
export default function StepIndicator({ steps = [], currentStep = 0 }) {
  if (steps.length === 0) return null;

  const clampedStep = Math.max(0, Math.min(currentStep, steps.length - 1));

  return (
    <div className="text-xs text-gray-500 mb-3">
      Step {clampedStep + 1} of {steps.length}
    </div>
  );
}
